import { InfoIcon } from '@/assets/icons/InfoIcon';
import OfferWallIcon from '@/assets/icons/OfferWallIcon';
import { OfferLabelIconType } from '@/types/offerWall';
import styles from './OfferLabel.module.scss';

interface Props {
  text: string;
  icon?: OfferLabelIconType;
  plusIcon?: boolean;
  className?: string;
  descriptionData?: { title?: string; description: string[] };
  dataPosition?: 'right' | 'left';
  isBottom?: boolean;
  repopulationPlusIcon?: boolean;
}

const OfferLabel = ({
  text,
  icon,
  plusIcon = true,
  className,
  descriptionData,
  dataPosition,
  isBottom = false,
  repopulationPlusIcon = false,
}: Props) => {
  return (
    <div className={`${styles.label} ${className || ''}`}>
      {icon && <OfferWallIcon icon={icon} className={styles.icon} />}
      <span className={styles.labelText}>{text}</span>
      {plusIcon && <InfoIcon className={`${styles.icon} ${styles.infoIcon}`} />}
      {repopulationPlusIcon && <div className={styles.plusIcon} />}
      {descriptionData && (
        <div
          className={`${styles.infoWrapper} ${dataPosition ? styles[dataPosition] : ''} ${isBottom ? styles.bottom : ''}`}
        >
          {descriptionData.title && (
            <p className={styles.infoTitle}>{descriptionData.title}</p>
          )}
          <ul className={styles.infoDescription}>
            {descriptionData.description.map((textValue) => (
              <li key={textValue}>{textValue}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default OfferLabel;
